import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-humidity',
    template: `
        <ng-template #template>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" [ngClass]="class">
          <path d="M5.5 2C5.5 2 2 6.167969 2 8.5C2 10.433594 3.566406 12 5.5 12C7.433594 12 9 10.433594 9 8.5C9 6.167969 5.5 2 5.5 2 Z M 18.5 4C18.5 4 15 8.167969 15 10.5C15 12.433594 16.566406 14 18.5 14C20.433594 14 22 12.433594 22 10.5C22 8.167969 18.5 4 18.5 4 Z M 11.5 12C11.5 12 8 16.167969 8 18.5C8 20.433594 9.566406 22 11.5 22C13.433594 22 15 20.433594 15 18.5C15 16.167969 11.5 12 11.5 12Z" fill="currentColor" />
        </svg>
        </ng-template>
    `,
})
export class IconHumidityComponent {
    @Input() fill: boolean = false;
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
